import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useLanguage } from '../context/LanguageContext';

const LoadingState = ({ message }) => {
  const { t } = useLanguage();
  const displayMessage = message || t('loading');

  return (
    <Box
      sx={{
        p: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        minHeight: 200,
      }}
    >
      <CircularProgress size={32} thickness={4} sx={{ color: 'primary.main', mb: 1.5 }} />
      <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600 }}>
        {displayMessage}
      </Typography>
    </Box>
  );
};

export default LoadingState;
